import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useJobDestinationParametersStore } from "@/stores/jobDestinationParametersStore";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobDestinationParams',
    props: {
        jobId: null
    },
    setup(__props) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const jobDestinationParametersStore = useJobDestinationParametersStore();
        const jobDestinationParams = computed(() => {
            return jobDestinationParametersStore.getJobDestinationParams(props.jobId);
        });
        return { __sfc: true, currentUser, jobDestinationParametersStore, props, jobDestinationParams };
    }
});
